/** Shared account endpoint map for all environment files. */
export function buildAccountEndpoints(baseApiRoot: string) {
  return {
    profile: `${baseApiRoot}/account/profile`,
    company: `${baseApiRoot}/account/company`,
    subscription: `${baseApiRoot}/account/subscription`,
    billing: `${baseApiRoot}/account/billing`,
    startPayment: `${baseApiRoot}/account/billing/start-payment`,
    startCheckout: `${baseApiRoot}/account/billing/start-checkout`,
    syncCheckout: `${baseApiRoot}/account/billing/sync-checkout`,
    confirmPayment: `${baseApiRoot}/account/billing/confirm-payment`,
    createQrPh: `${baseApiRoot}/account/billing/qrph`,
    cancelQrPh: `${baseApiRoot}/account/billing/qrph/cancel`,
    resumeQrPh: `${baseApiRoot}/account/billing/qrph/resume`,
    invoiceStatus: (invoiceId: number) => `${baseApiRoot}/account/billing/invoices/${invoiceId}`,
    clearPaymentMethod: `${baseApiRoot}/account/billing/payment-method`,
    setAutoRenew: `${baseApiRoot}/account/billing/auto-renew`,
    retryProvision: `${baseApiRoot}/account/retry-provision`,
    invoices: `${baseApiRoot}/account/invoices`,
    invoicePdf: (invoiceId: number) => `${baseApiRoot}/account/invoices/${invoiceId}/pdf`,
    changePlan: `${baseApiRoot}/account/change-plan`,
    enableStaffingAddOn: `${baseApiRoot}/account/addons/staffing/enable`,
    changePassword: `${baseApiRoot}/account/change-password`,
  };
}

export function buildAuthEndpoints(baseApiRoot: string) {
  return {
    register: `${baseApiRoot}/auth/register`,
    login: `${baseApiRoot}/auth/login`,
    refresh: `${baseApiRoot}/auth/refresh-token`,
    verifyEmail: `${baseApiRoot}/auth/verify-email`,
    forgotPassword: `${baseApiRoot}/auth/forgot-password`,
    resetPassword: `${baseApiRoot}/auth/reset-password`,
  };
}

export function buildLeadsEndpoints(baseApiRoot: string) {
  return {
    requestDemo: `${baseApiRoot}/leads/demo`,
  };
}
